module.exports = __webpack_public_path__ + "img/administration.5b6a9618.svg";